import Layout from '@/layout'
export default [
    {
        path: '/attendances',
        component: Layout,
        children: [
            {
                path: 'import',
                name: 'attendanceImport',
                component: () => import('./Import'),
                meta: { title: 'Import Attendance', icon: 'tree' },
                adminOnly: true,
            },
        ]
    },
]